"use strict";

import React, { useEffect, useLayoutEffect, useState } from 'react';
import { CaptureFieldDefinition } from '../captureprofilemanager/CaptureFieldDefinition';
import { useCaptureProfileContext } from '../captureprofilemanager/captureProfileContext';
import { CaptureProfileFormRendererProps } from './types';

export const CaptureProfileForm = ({fields, isClient}: CaptureProfileFormRendererProps) => {

    const { setFields, ...ctx } = useCaptureProfileContext();
    const [ dirty, setDirty ] = useState(0);


    window.CustomEditors = window.CustomEditors || [];

    useEffect(() => {
        const captureFieldDefinitions : CaptureFieldDefinition[] = fields.map(v => {
        
        const def: CaptureFieldDefinition = {
            alias: v.alias,
            alwaysExcludeFromBulkActionsSpreadsheet: false,
            alwaysExcludeFromPrintableCourseSummary: false,
            builtInValidator: '',
            defaultValue: v.defaultValue,
            editCompletedFieldPrivilegeScope: 0,
            editCompletedFieldPrivilegeSpec: null,
            editFieldPrivilegeScope: 0,
            editFieldPrivilegeSpec: null,
            editor: v.editor,
            failedValidationMessage: v.valmessage,
            id: v.id,
            indicatesSpecialRequirement: false,
            internalOnly: false,
            isRequired: v.required,
            mapsToBuiltInProperty: '',
            name: v.label,
            originalValue: v.originalValue,
            possibleValues: null,
            possibleValuesList: v.possibleValuesList,
            preventEdit: v.readonly || v.disabled,
            regExValidator: v.regex,
            sort: 0,
            value: v.value,
            viewCompletedFieldPrivilegeScope: 0,
            viewCompletedFieldPrivilegeSpec: null,
            viewFieldPrivilegeScope: 0,
            viewFieldPrivilegeSpec: null,
            extraSettings: v.extraSettings,
            format: v.format,
            captureProfileFieldIdFieldName: v.captureProfileFieldIdFieldName,
            valueFieldName: v.valueFieldName

        }
        return def;
    })
        setFields!(captureFieldDefinitions);
    }, [fields]);

    // bit of a cheap trick to make the global array of available editors observable
    var _array = [...window.CustomEditors];
    window.CustomEditors = new Proxy(_array, {
        deleteProperty: function(target, property : any) {
            delete target[property];
            setDirty(dirty + 1)
            return true;
        },
        set: function(target, property : any, value, receiver) {      
            target[property] = value;
            setDirty(dirty + 1)
            return true;
            
        }
    });

    const hasAnyPrivilege = (requiredPrivileges : string[]) => {
        return requiredPrivileges.some((c) => {
            return ctx.privileges.includes(c.toUpperCase()); 
        })
    };


    return <div>
        {
            ctx && ctx.fields && 
            ctx.fields.map((v,i) => {
                const editor = window.CustomEditors ? window.CustomEditors.find(x => x.name.toLowerCase() === v.editor.toLowerCase()) : undefined;
                let props = {
                    isClient: isClient,
                    label: v.name,
                    name: v.valueFieldName,
                    required: v.isRequired,
                    alias: v.alias,
                    valmessage: v.failedValidationMessage,
                    // validation: ,
                    regex: v.regExValidator,
                    options: v.possibleValuesList,
                    value: v.preventEdit ? v.originalValue ?? '' : v.value ? v.value : v.defaultValue ? v.defaultValue : '',
                    disabled: v.preventEdit,
                    readonly: v.preventEdit,
                    defaultValue: v.defaultValue,
                    format: v.format,
                    onChangeHandler: function (event: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>) {
                        // translate value from editor - sometimes the editors
                        // store specific values for state representation.

                        let newValue = event.target.value;

                        if(editor && editor.translateValueFromDomEvent) newValue = editor.translateValueFromDomEvent(event);
                        
                        if(ctx.updateFieldValue) ctx.updateFieldValue(v.alias, newValue);

                        //rThis.setState({ values: values });

                        return true;
                    },
                    validationSyncHandler: function (results : any) { // TODO: work out a better type for this
                        var fields = Object.assign([], ctx.fields) as CaptureFieldDefinition[]; 

                        results.map((x: { field: string; validation: { isValid: any; errors: { errorMessage: string | null; }[]; }; }) => {
                            var targetField = fields.find(f => f.id === x.field);
                            if (targetField) {
                                if (!x.validation.isValid) {
                                    targetField.failedValidationMessage = x.validation.errors[0].errorMessage;
                                }
                                else {
                                    targetField.failedValidationMessage = '';
                                }
                            }

                        });


                        if(setFields) setFields(fields);
                    }
                };

                if (editor) {
                    const Edtr = editor!.editor;
                    
                    return (
                        <React.Fragment key={v.alias}>
                            <div >
                                <div className="form-group" data-editor={v.editor} >
                                    <input type="hidden" name={v.captureProfileFieldIdFieldName} value={v.id} />
                                    <Edtr {...props} context={ctx} />
                                </div>
                            </div>
                        </React.Fragment>
                    )
                }
            })
        }
    </div>
}